import * as React from "react";
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
import * as types from "../../constants/actionTypes";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import * as ProxyHelper from "../proxyManagement/ProxyHelper";
import Spinner from "../common/spinner";
import ProxySelect from "./ProxySelect";

class ProxySuggestions extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            userList:[]
        }
    }

    componentDidMount() {
        const { useOnboardingLayout, getRequestProxySuggestion } = this.props;
        logUI(`MBHWeb.UI.ProxySuggestions.ComponentDidMount${ProxyHelper.getLogLayoutStatus(useOnboardingLayout)}`, new Date(), Tools.getURLPath());
        this.populatePreCheckedProxySelect();
    }

    populatePreCheckedProxySelect = () => {
        const { newProxySuggestionList, selectedProxySuggestionUsers } = this.props;
        const userList = newProxySuggestionList;
        if (selectedProxySuggestionUsers?.length) {
            selectedProxySuggestionUsers.forEach((u) => {
                if (u.isChecked) {
                    userList?.forEach(ep => {
                        if (u.id === ep.id) {
                            ep.isChecked = true;
                        }
                    })
                }
            })
        }
        this.setState({userList:userList})
    }

    handleAddMembers = () => {
        const { setSelectedProxyUsers,history,useOnboardingLayout } = this.props;
        let checkedUsers = this.state.userList.filter((user) => {
            return user.isChecked === true
        });
        setSelectedProxyUsers(checkedUsers);
        logUI(`MBHWeb.UI.ProxySuggestions.AddFamilyMember.Clicked${ProxyHelper.getLogLayoutStatus(useOnboardingLayout)}`,
            new Date(), Tools.getURLPath(), { selectedUserCount: checkedUsers.length, selectedUsers: checkedUsers });
        this.UpdatePreference('AddFamilyMember')
        history.push({ pathname: '/onboarding/proxyrequestDOB'});

    }

    UpdatePreference(linkName) {
        const { useOnboardingLayout,updateFamilyMembersScreenPreference } = this.props;
        logUI(`MBHWeb.UI.ProxySuggestions.${linkName}.Clicked${ProxyHelper.getLogLayoutStatus(useOnboardingLayout)}`, new Date(), Tools.getURLPath());
        updateFamilyMembersScreenPreference && updateFamilyMembersScreenPreference();
    }

    handleCheck = (id) => {
        const { userList } = this.state;
        const updatedList = userList.map(user => (user.id === id ? { ...user, isChecked: !user.isChecked } : user));
        this.setState({ userList: updatedList });
    }

    isButtonEnabled = () => {
        const { userList } = this.state;
        if (userList.length) {
            return userList.some((user) => {
                return (user.isChecked === true);
            })
        }
        return false;
    }

    render() {
        const { hasFirstCare, healthPlanData, newProxySuggestionList } = this.props;
        const healthPlanName = healthPlanData && healthPlanData.PlanName ? healthPlanData.PlanName : hasFirstCare ? "FirstCare Health Plans" : "Baylor Scott & White Health Plan";
        const subHeading = <>Connect your account to family members covered by your plan to manage their health.</>;
        const proxySelectInfo = "You will be able to add or remove family members or grant someone permission to manage your health care from your profile.";


        return (
            <>
                <div className="container-fluid proxy-suggestions-container">
                    <div className="row">
                        <div className="col-12 maxWidth-content">
                            <h1 className="onboarding-layout__page-heading">{healthPlanName}</h1>
                        </div>
                        <div className="col-12 maxWidth-content">
                            <div className="row proxy-suggestions__body">
                                <div className="col-12">
                                    <div className="row">
                                        <div className="col-12" >
                                            <p className="proxy-suggestions__subheading">{subHeading}</p>
                                        </div>
                                    </div>
                                    {/*Display Proxy List */}
                                    <ProxySelect userList={this.state.userList} handleCheck={this.handleCheck} />
                                </div>
                            </div>
                            <div className="row text-center proxy-suggestions__footer">
                                <div className="col-12 proxy-suggestion-content" >
                                    <p className="proxy-suggestion-info" >{proxySelectInfo}</p>
                                </div>
                                <div className="col-12" >
                                    <button className="btn btn-primary" disabled={!this.isButtonEnabled()}
                                        onClick={() => this.handleAddMembers()}>ADD FAMILY MEMBERS</button>
                                </div>
                                <div className="col-12">
                                    <Link to={{ pathname: '/onboarding/managenotifications' }}
                                        className="btn text-btn"
                                        onClick={() => { this.UpdatePreference('NoThanks') }}>
                                        SKIP ADDING FAMILY MEMBERS
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {(newProxySuggestionList === null) &&
                    <>
                        <div className="row overlay-loading-container">
                            <div className="col-12 align-self-center">
                                <Spinner />
                            </div>
                        </div>
                    </>
                }
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        useOnboardingLayout: state.session.useOnboardingLayout,
        newProxySuggestionList: state.session.newProxySuggestionList,
        selectedProxySuggestionUsers: state.session.selectedProxySuggestionUsers,
        hasProxySuggestions: state.session.hasProxySuggestions,
        healthPlanData: state.healthPlan.healthPlanTileData,
        hasFirstCare: state.memberships.hasFC,
        history: state.session.history
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getRequestProxySuggestion: () => dispatch({ type: types.REQUEST_PROXY_SUGGESTION_LIST }),
        setSelectedProxyUsers: (selectedProxySuggestionUsers) => dispatch({
            type: types.SET_PROXY_SELECTED_USERS, selectedProxySuggestionUsers}),
        updateFamilyMembersScreenPreference: () => dispatch({ type: types.UPDATE_FAMILYMEMBERS_SCREEN_PREFERENCE }),

    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ProxySuggestions);